import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from './config'

const functions = getFunctions(app, 'us-central1')

// Call admin functions
export const ensureAdminClaim = httpsCallable(functions, 'ensureAdminClaim')
export const setAdminByOwner = httpsCallable(functions, 'setAdminByOwner')
export const revokeAdmin = httpsCallable(functions, 'revokeAdmin')
export const ensureUserProfile = httpsCallable(functions, 'ensureUserProfile')
export const updateUsername = httpsCallable(functions, 'updateUsername')

// Prompt admin CRUD (golden source)
export const createPromptAdmin = httpsCallable(functions, 'createPromptAdmin')
export const updatePromptAdmin = httpsCallable(functions, 'updatePromptAdmin')
export const deletePromptAdmin = httpsCallable(functions, 'deletePromptAdmin')

// Modération de contenu (issue #75) — garde UX avant sauvegarde des textes
// libres de /slots (le verrou dur est côté serveur, generateImage/apiGenerate)
export const moderateText = httpsCallable(functions, 'moderateText')

// Remise à zéro des strikes de modération d'un utilisateur + réactivation du
// compte (issue #75) — bouton « Reset » de l'onglet Compliance de
// /admin-datadog (callable admin, Admin SDK)
export const resetComplianceStrikes = httpsCallable(functions, 'resetComplianceStrikes')

// Purge des données de dev de l'onglet Compliance (moderationEvents + strikes
// de tous les utilisateurs + réactivation des comptes suspendus) — bouton
// « Clear dev data » de /admin-datadog/compliance (callable admin, Admin SDK)
export const clearComplianceData = httpsCallable(functions, 'clearComplianceData')